/**
 * Formats a `{ city, state }` shape into a `"City, State"` display string.
 * The state is dropped when absent or blank; returns `null` when there is no
 * city so the caller can fall back to a placeholder.
 *
 * @example formatLocation({ city: 'San Francisco', state: 'CA' }) // "San Francisco, CA"
 * @example formatLocation({ city: 'London', state: null }) // "London"
 * @example formatLocation(null) // null
 */
export default function formatLocation(location: { city: string; state?: string | null } | null): string | null {
  if (location === null || location.city.trim().length === 0) {
    return null;
  }
  const state = location.state?.trim();
  return state ? `${location.city}, ${state}` : location.city;
}
